import axiosInstance from './axios.service'
import BaseUrl from "./url.service"

const serverUrl = `${BaseUrl}/requirement`


export const getAllRequirements = async (query) => {
    return axiosInstance.get(`${serverUrl}/?${query}`)
}

export const getById = async (id) => {
    return axiosInstance.get(`${serverUrl}/getById/${id}`)
}

export const deleteRequirementById = async (id) => {
    return axiosInstance.delete(`${serverUrl}/deleteById/${id}`)
}

export const AddRequirement = async (obj) => {
    return axiosInstance.post(`${serverUrl}/createRequirement`, obj)
}
export const updateRequirementById = (id, formData) => {
  return axiosInstance.patch(`${serverUrl}/updateById//${id}`, formData)
}
  